// extracted by mini-css-extract-plugin
export default {"lastSave":"O9lXh","form":"PSfxb","header":"ey5I1","name":"Oubla","actions":"_4IcZ","action":"i1oa1"};